<template>
<body class="min-h-screen bg-gray-100">
  <div id="wrapper">
    <Header />

    <router-view></router-view>

    <Footer />
  </div>
</body>
</template>

<script>
import "@/assets/css/tailwind.css";
import "@/assets/css/main.css";

import Vue from "vue";
import { router } from "./_router.js";
import { store } from "./_store.js";

import { library } from "@fortawesome/fontawesome-svg-core";
import { faEnvelope } from '@fortawesome/free-solid-svg-icons'
import {
    faFacebook,
    faTwitter,
    faInstagram,
    faDev,
    faAppStore,
    faGooglePlay,
    faDiscord,
    faAmazon
} from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

library.add(faEnvelope);
library.add(faTwitter);
library.add(faInstagram);
library.add(faFacebook);
library.add(faDev);
library.add(faGooglePlay);
library.add(faAppStore);
library.add(faAmazon);
library.add(faDiscord);

Vue.component("font-awesome-icon", FontAwesomeIcon);

import { VLazyImagePlugin } from "v-lazy-image";
Vue.use(VLazyImagePlugin);

import Header from "./components/Header";
import Footer from "./components/Footer";

export default Vue.extend({
  store,
  router,

  components: {
    Header,
    Footer
  }
});
</script>
